import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import StockReportLayout from './report/stock_report_wrapper';

const StockReport = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <StockReportLayout />
            </ContainerComponent>
        </>
    );
}

export default StockReport;